<template>
  <v-navigation-drawer
    id="drawer-small-screen"
    v-model="isOpen"
    absolute
    temporary
    width="250"
    class="brown lighten-5"
  >
    <drawer-content />
  </v-navigation-drawer>
</template>

<script>
import DrawerContent from './DrawerContent.vue'

export default {
  components: {
    DrawerContent
  },
  props: {
    value: {
      type: Boolean
    }
  },
  data() {
    return {
      isOpen: this.value
    }
  },
  watch: {
    value(newVal) {
      this.isOpen = newVal
    },
    isOpen(newVal) {
      if (!newVal) {
        this.$emit('input', false)
      }
    }
  }
}
</script>

<style scoped>
::-webkit-scrollbar {
  display: none;
}
</style>
